import { render, staticRenderFns } from "./results.vue?vue&type=template&id=b37e6fb2&scoped=true&"
import script from "./results.vue?vue&type=script&lang=js&"
export * from "./results.vue?vue&type=script&lang=js&"
import style0 from "./results.vue?vue&type=style&index=0&id=b37e6fb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37e6fb2",
  null
  
)

export default component.exports